import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import Notification from '../../../components/Notification';

class LoginLayout extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
  };
  render() {
    return (
      <div>
        <div className="container-fluid login">
          <div className="row">
            <div className="col-md-4 center-block">
              {this.props.children}
            </div>
          </div>
        </div>
        <Notification />
      </div>
    );
  }
}

export default LoginLayout;



// WEBPACK FOOTER //
// src/routes/login/containers/LoginLayout.js